import { readable } from 'svelte/store'

// Default value should be true, to be safe   ⬇️
export const isMobile = readable(true, function (set) {
  // No behavior unless we're in a browser.
  let stop = () => {}

  if (typeof window != 'undefined') {
    let mediaQuery = window.matchMedia('(max-width: 700px)')
    // Define a function that sets the store to match the media query
    const setMatches = () => set(mediaQuery.matches)
    // Call it once now
    setMatches()
    // Call it on changes
    mediaQuery.addEventListener('change', setMatches)
    // Set the stop function which will be returned
    stop = () => mediaQuery.removeEventListener('change', setMatches)
  }

  return stop
})
